import { useCallback, useEffect, useRef } from 'react';
import { useResizeEnd } from 'src/hooks/useResizeEnd';
const FRAME_COUNT = 48;
const LOAD_BREAK_POINT = FRAME_COUNT / 3;

export const currentFrame = (index: number) => `/images/vision/puzzle.163.${index}.png`;

function usePreloader() {
    const preloadImages = (offset: number, limit: number) => {
        const img = new Image();
        img.src = currentFrame(offset);

        img.onload = function () {
            if (offset < limit - 1) {
                preloadImages(offset + 1, limit);
            }
        };
    };

    useEffect(() => {
        preloadImages(1, LOAD_BREAK_POINT);
        preloadImages(LOAD_BREAK_POINT, 2 * LOAD_BREAK_POINT);
        preloadImages(2 * LOAD_BREAK_POINT, 3 * LOAD_BREAK_POINT);
    }, []);
}

export const useHiwScroll = () => {
    usePreloader();
    const imageRef = useRef<HTMLImageElement | null>();
    const maxScrollSpace = useRef(0);

    const onscroll = (_: any) => {
        // context.current?.clearRect(0, 0, window.innerWidth / 2, window.innerWidth / 3);
        const scrollTop = window.scrollY;
        const scrollFraction = scrollTop / maxScrollSpace.current;
        const index =
            Math.max(Math.min(FRAME_COUNT, Math.ceil(scrollFraction * FRAME_COUNT)), 1) || 1;

        updateImage(index);
        // requestAnimationFrame(() => updateImage(index));
    };

    function updateImage(index: number) {
        if (imageRef.current) imageRef.current.src = currentFrame(index);
    }

    const setCanvas = useCallback(() => {
        const interval = setInterval(() => {
            const puzzle = document.getElementById('puzzle-animation') as HTMLImageElement;
            const footer = document.getElementById('APSY-Footer');
            const content = document.getElementsByClassName('Apsy-values-container');
            if (puzzle && footer && content) {
                clearInterval(interval);
                imageRef.current = puzzle;
                const contentHight = content[0].getBoundingClientRect().height;
                const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
                const footerHeight = footer.getBoundingClientRect().height;
                if (window.innerHeight > contentHight) {
                    maxScrollSpace.current = footerHeight;
                } else maxScrollSpace.current = scrollHeight - footerHeight;
            }
        }, 50);
    }, []);

    const onResize = useCallback(() => {
        setCanvas();
    }, []);
    const onResizeEnd = useResizeEnd(250, onResize);

    useEffect(() => {
        setCanvas();
        window.addEventListener('scroll', onscroll);
        window.addEventListener('resize', onResizeEnd);
        requestAnimationFrame(() => updateImage(1));
        return () => {
            window.removeEventListener('scroll', onscroll);
            window.removeEventListener('resize', onResizeEnd);
        };
    }, []);

    return null;
};
